import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService, ConfigServerService, CustomHttp } from '../../../core';
import { ILocalFaturamentoPrazoEntrega, LocalFaturamento } from '../local-faturamento';
import { LocalFaturamentoFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class LocalFaturamentoCrudHttpService implements Crud<LocalFaturamento> {
    resource = 'localfaturamento';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todos os locais de faturamentos cadastrados */
    search(incluirPadrao = false): Observable<LocalFaturamento[]> {
        const params = incluirPadrao ? new HttpParams().set('includes', 'padrao') : undefined;
        return this.crudService.search<LocalFaturamento>(this.resource, {params});
    }


    searchWithFilter(filter: LocalFaturamentoFilter): Observable<LocalFaturamento[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get(this.pathApi, {params});
    }

    /** Procura um único local de faturamento através do seu ID */
    find(id: number): Observable<LocalFaturamento> {
        return this.crudService.find<LocalFaturamento>(this.resource, id);
    }

    /** Carrega um único local de faturamento através do seu ID */
    load(id: number): Observable<LocalFaturamento> {
        return this.crudService.load<LocalFaturamento>(this.resource, id);
    }

    /** Prazos de entrega das 27 UFs do local; com id 0, a lista em branco para a inclusão */
    prazosEntregas(id: number): Observable<ILocalFaturamentoPrazoEntrega[]> {
        return this.customHttp.get(`${this.pathApi}/${id}/prazos-entregas`);
    }

    /** Insere um novo local de faturamento */
    insert(entity: LocalFaturamento): Observable<LocalFaturamento> {
        return this.crudService.insert<LocalFaturamento>(this.resource, entity);
    }

    /** Altera um local de faturamento existente */
    update(entity: LocalFaturamento): Observable<LocalFaturamento> {
        return this.crudService.update<LocalFaturamento>(this.resource, entity);
    }

    /** Exclui um local de faturamento através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
